var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("navigation-layout", { ref: "navigationlayout" }, [
    _c("h1", { attrs: { slot: "title" }, slot: "title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { slot: "abstract" }, slot: "abstract" }, [
      _vm._v(_vm._s(_vm.abstract))
    ]),
    _vm._v(" "),
    _c("main", [
      _c(
        "form",
        {
          staticClass: "md-layout",
          attrs: { novalidate: "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.validateUsername($event)
            }
          }
        },
        [
          _c("field", {
            ref: "username",
            attrs: {
              fieldName: "username",
              validations: { required: true },
              fieldValue: _vm.form.username,
              fieldLabel: "Username",
              fieldId: "username",
              sending: _vm.sending
            },
            on: {
              setfield: function($event) {
                return _vm.setFormField($event)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "md-radio",
            {
              attrs: { value: 0 },
              model: {
                value: _vm.form.accountkind,
                callback: function($$v) {
                  _vm.$set(_vm.form, "accountkind", $$v)
                },
                expression: "form.accountkind"
              }
            },
            [_vm._v("Standard")]
          ),
          _vm._v(" "),
          _c(
            "md-radio",
            {
              attrs: { value: 1 },
              model: {
                value: _vm.form.accountkind,
                callback: function($$v) {
                  _vm.$set(_vm.form, "accountkind", $$v)
                },
                expression: "form.accountkind"
              }
            },
            [_vm._v("Integration")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "md-layout" }, [
            _c(
              "div",
              { staticClass: "md-layout-item md-small-size-100 right-align" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-raised md-primary",
                    attrs: { type: "submit", disabled: _vm.sending }
                  },
                  [_vm._v("Save")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f6768a0", { render: render, staticRenderFns: staticRenderFns })
  }
}